import { LeasePacketSection } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { useUnlockedLeasePacketSection } from './hooks';

function UnlockedLeasePacket(props) {
  const clProps = useUnlockedLeasePacketSection(props);
  return <LeasePacketSection {...clProps} />;
}

export default UnlockedLeasePacket;
